// "Create New Shop" -- shown only to accounts whose role may own shops of this
// type (answer of GET /shops/mine). At the limit it stays visible but
// disabled, with the limit spelled out ("3 / 3 Shops · Maximum shops reached.").
import React, { useState } from "react";
import { FaPlus } from "react-icons/fa";
import { elakayAutoText as text } from "../pageInside/dataElakay";
import { useAccountShops } from "./accountShopsStore";
import CreateShopModal from "./CreateShopModal";
import "./shops.css";

const CreateShopButton = ({ type = "seller", compact = false, onCreated }) => {
  const { data } = useAccountShops();
  const [show, setShow] = useState(false);
  if (!data || !(data.types || []).includes(type)) return null;
  const quota = data.quota || { count: 0, max: 0, canCreate: false };
  const limitText = text("h_msh_quota", "{value0} / {value1} Shops", { value0: quota.count, value1: quota.max });
  return (
    <span className={`msh-create${compact ? " msh-create-compact" : ""}`}>
      <button
        type="button"
        className="msh-btn msh-btn-create"
        onClick={() => setShow(true)}
        disabled={!quota.canCreate}
        aria-describedby={!quota.canCreate ? `msh-limit-${type}` : undefined}
        title={text("h_msh_create_new_shop", "Create New Shop")}
      >
        <FaPlus aria-hidden="true" /> <span className="msh-btn-text">{text("h_msh_create_new_shop", "Create New Shop")}</span>
      </button>
      {!quota.canCreate && (
        <span id={`msh-limit-${type}`} className="msh-limit">
          {!compact && `${limitText} · `}{text("h_msh_max_reached", "Maximum shops reached.")}
        </span>
      )}
      <CreateShopModal show={show} onHide={() => setShow(false)} data={data} defaultType={type} onCreated={onCreated} />
    </span>
  );
};

export default CreateShopButton;
